module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTI1NiAwaDI1NnY1MTJIMjU2eiIvPgogIDxwYXRoIGZpbGw9IiMwMDYyMzMiIGQ9Ik0wIDBoMjU2djUxMkgweiIvPgogIDxwYXRoIGQ9Ik0zNjYuOTMzIDE5MmExMjggMTI4IDAgMSAwIDAgMTI4IDEwMi40IDEwMi40IDAgMSAxIDAtMTI4bTQuMjY3IDY0TDI1NiAyMTguNDUzbDcxLjY4IDk4LjEzNFYxOTUuNDEzTDI1NiAyOTMuNTQ3eiIgZmlsbD0iI2QyMTAzNCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/dz.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/dz.svg
// module chunks = 0